//
// AbstractOverlay.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/DataVisualization";

var AbstractOverlay = createModule("gtl::AbstractOverlay", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::DataVisualization"], EventDispatcher, [
    ,
    {
        visible: 2,
        legendLabel: 7,
        reverseColorModel: 2,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default AbstractOverlay;
